export function getElements(baseElement) {
  const elementWithDataJS = Array.from(
    baseElement.querySelectorAll("[data-js]")
  );

  const elements = Object.fromEntries(
    elementWithDataJS.map((element) => {
      const keyPascal = element.dataset.js
        .split("-")
        .map((word) => {
          word = word[0].toUpperCase() + word.substring(1);
          return word;
        })
        .join("");
      const key = keyPascal[0].toLowerCase() + keyPascal.substring(1);
      return [key, element];
    })
  );

  return elements;
}
